import Message from './message.vue'

let message = {}
message.install = (Vue) => {
    if (document.getElementsByClassName('.totalMessage').length) return
    let obj = Vue.extend(Message);
    let $vm = new obj();
    let tpl = $vm.$mount().$el;
    document.body.appendChild(tpl);
    Vue.prototype.$Message = {
        show(data) {
            if (data) {
                // $vm.auto = false;
                $vm.text = data
                setTimeout(showmessage, 0);
            }
            // $vm.show = true;
        },
        hide() {
            $vm.show = false;
        }
    }

    function showmessage() {
        $vm.show = true
        var num = 1.5
        setTimeout(() => {
            $vm.show = false
        }, 1500);
    }
}

// function showmessage() {
//     this.show = true
// }
export default message